import React from 'react';
import { withIcon } from '../../../../components/withIcon/withIcon.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgTwitterFilled = (_a) => {
  var _b = _a, { size, title = "TwitterFilled" } = _b, props = __objRest(_b, ["size", "title"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    "data-icon-name": title,
    "aria-label": title,
    role: "presentation"
  }, props), /* @__PURE__ */ React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M5.1 10.378l-1.456-.387c.09 1.708 1.199 2.88 2.724 3.518h-1.42c.616 1.472 1.87 2.261 3.424 2.46-1.584 1.12-3.45 1.553-5.372 1.465 3.828 2.347 9.02 1.993 12.51-.821a10.023 10.023 0 003.19-4.525c.312-.912.46-1.845.52-2.804.068-1.126 1-1.678 1.78-2.435-.215-.225-1.623.304-1.913.376.503-.498 1.282-1.065 1.346-1.83-.528.186-1.132.504-1.677.597-.626.105-.88-.212-1.395-.502a3.882 3.882 0 00-2.613-.422c-2.25.426-2.875 2.236-3.001 4.26-2.957-.2-5.605-1.515-7.605-3.693-.806 1.747-.438 3.436.957 4.743z"
  })));
};
var TwitterFilled = withIcon(SvgTwitterFilled);

export { TwitterFilled as default };
//# sourceMappingURL=TwitterFilled.es.js.map
